module.exports = __webpack_public_path__ + "static/media/favorite-filled.b2fd20c3.svg";